module.exports = __webpack_public_path__ + "img/bg-menu.c330591e.png";